import React, { useState } from 'react'
import Dropzone from 'react-dropzone'
import translate from '../../reusable/translate'
import { useSelector } from "react-redux";
const ProfilePicture = ({ onSelect, profilePic, allowDelete }) => {

    const [profilePicture, setProfilePicture] = useState(profilePic)
    const maxImageSize = 300000 // 0.3MB


    const handleSelect = (file) => {
        const f = file[0]
        const fileReader = new FileReader()

        fileReader.onload = (file) => {
            return ((e) => {
                setProfilePicture(e.target.result)
                onSelect(e.target.result)
            })(file)
        }

        if (f) {
            fileReader.readAsDataURL(f)
        }
    }

    const handleRejection = (rejectedFile) => {
        if (rejectedFile.size > maxImageSize){
            alert('Image size is too big. Max file size is ' + maxImageSize/1000000 + 'MB')
        } else {
            alert('Couldn\'t process the image. Check the file type')
        }
    }

    return (
        <div>
            {profilePicture &&
                <ProfilePictureDisplay
                    profilePicture={profilePicture}
                    allowDelete={allowDelete}
                />
            }
            {!profilePicture &&
                <Dropzone
                    multiple={false}
                    accept="image/jpg, image/jpeg, image/png, image/svg"
                    maxSize={maxImageSize}
                    onDrop={(e) => handleSelect(e)}
                    onDropRejected={(rejectedFile) => handleRejection(rejectedFile[0])}
                    style={{ width: 200, height: 200 }}
                >
                    <DropZoneContentDisplay/>
                </Dropzone>}
        </div>
    )
}

export default ProfilePicture

const ProfilePictureDisplay = ({ profilePicture, allowDelete }) => {
    return(
        <div className="flex-column">
            <img className="profile-pic" src={profilePicture} alt={'kuva'}/>
            {allowDelete && <button>{translate({ textKey: 'sit.profilePic.removePic' })}</button>}
        </div>
    )
}

const DropZoneContentDisplay = () => {
    const { language } = useSelector(state => state);
    return(
        <div className="commitment-logo">
            <i className="fas fa-plus-circle"/>
            <p className="p">
                {translate({
                    textKey: 'sit.profilePic.addLogo',
                    languageOverride: language 
                })}
            </p> 
            <em>.jpg, .png, .svg</em>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/components/materialCommitment/commitment/ProfilePicture.jsx